
    <!-- Top-->
    <div fxLayout="row" fxLayoutGap="5px" fxLayout.lt-lg="column" fxFlex="calc(50% - 20px)" fxFlex.lt-md="100%">
        <div>
            <div>
                <mat-card class="exact-card-small-top">
                    <mat-card-content>
                        <img src="assets/logoExact.png" class="exact-card-small-logo"/>
                    </mat-card-content>
                </mat-card>
            </div>
            <div *ngIf="canDoExact()">
                <mat-card class="exact-card-small-login">
                    <mat-card-content>
                        <button mat-button (click)="this.Authenticate()">Inloggen Exact</button>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>  
    </div>
